exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".interest-buttons[data-v-8778a924]{margin-top:50px}.interest-header[data-v-8778a924]{font-size:26px;font-weight:700;padding-bottom:35px}.onboard-interest__item[data-v-8778a924]{border-radius:10px}.ctt-card__cont[data-v-8778a924]{min-height:270px}@media screen and (max-width:767.97px){.ctt-card__cont[data-v-8778a924]{min-height:150px}.onboard-interest[data-v-8778a924]{margin-top:25px;padding:0 10px}.onboard-interest__action[data-v-8778a924]{margin-top:25px;font-size:14px}.onboard-interest__item.active~.onboard-interest__item[data-v-8778a924]{padding:0 10px}}", ""]);

// exports
